import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
	return twMerge(clsx(inputs));
}

/**
 * Format a date string to a localized date (e.g., "14 Dec 2024")
 */
export function formatDate(dateStr: string): string {
	return new Date(dateStr).toLocaleDateString("en-IN", {
		day: "numeric",
		month: "short",
		year: "numeric",
	});
}

/**
 * Format a date string to a localized date with time (e.g., "14 Dec 2024, 10:30 AM")
 */
export function formatDateTime(dateStr: string): string {
	return new Date(dateStr).toLocaleDateString("en-IN", {
		day: "numeric",
		month: "short",
		year: "numeric",
		hour: "2-digit",
		minute: "2-digit",
	});
}

/**
 * Format a date string to a localized date with time and long month (e.g., "14 December 2024, 10:30 AM")
 */
export function formatDateTimeLong(dateStr: string): string {
	return new Date(dateStr).toLocaleString("en-IN", {
		day: "numeric",
		month: "long",
		year: "numeric",
		hour: "2-digit",
		minute: "2-digit",
	});
}

/**
 * Format a number in Indian numbering system (e.g., 200000 → "2,00,000")
 */
export function formatIndianNumber(value: string | number): string {
	const num = typeof value === "string" ? value.replace(/\D/g, "") : String(value);
	if (!num) return "";
	return Number(num).toLocaleString("en-IN");
}

/**
 * Parse a formatted Indian number string back to raw digits (e.g., "2,00,000" → "200000")
 */
export function parseIndianNumber(value: string): string {
	return value.replace(/,/g, "");
}
